import api from './client';
import type {
  AtualizarMarcaGestaoLoteRequest,
  AtualizarMarcaGestaoLoteResponse,
  MarcaGestaoListItem,
  SalvarMarcaGestaoRequest,
} from '../types/marcaGestao';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

// Re-export pra retrocompat com componentes da Reposição (CardMarca,
// MarcaDetalheDrawer, etc) que importam o tipo de domínio com nome curto.
export type MarcaGestao = MarcaGestaoListItem;

class MarcaGestaoApi {
  async listar(incluirInativas = true): Promise<MarcaGestaoListItem[]> {
    const r = await api.get<ApiResponse<MarcaGestaoListItem[]>>('/marcas-gestao', {
      params: { incluirInativas },
    });
    return r.data.data;
  }

  async obter(marcaCodigo: string): Promise<MarcaGestaoListItem> {
    const r = await api.get<ApiResponse<MarcaGestaoListItem>>(
      `/marcas-gestao/${encodeURIComponent(marcaCodigo)}`,
    );
    return r.data.data;
  }

  async salvar(marcaCodigo: string, req: SalvarMarcaGestaoRequest): Promise<MarcaGestaoListItem> {
    const r = await api.put<ApiResponse<MarcaGestaoListItem>>(
      `/marcas-gestao/${encodeURIComponent(marcaCodigo)}`,
      req,
    );
    return r.data.data;
  }

  async atualizarLote(req: AtualizarMarcaGestaoLoteRequest): Promise<AtualizarMarcaGestaoLoteResponse> {
    const r = await api.put<ApiResponse<AtualizarMarcaGestaoLoteResponse>>(
      '/marcas-gestao/lote',
      req,
    );
    return r.data.data;
  }
}

export const marcaGestaoApi = new MarcaGestaoApi();
